import { Outlet } from "react-router-dom";
import { LogoContainer, Brand, LogoImage, NavigationContainer } from "./navigation.styles";
import { ReactComponent as CrownLogo } from "../../assets/crown.svg";

const LandingLayout = () => {
  return (
    <>
      <NavigationContainer>
        <LogoContainer to="/">
          <LogoImage>
            <CrownLogo />
          </LogoImage>
          <Brand>TEAM Bakery</Brand>
        </LogoContainer>
      </NavigationContainer>
      <Outlet />
    </>
  );
};

export default LandingLayout;
